export default "__VITE_ASSET__D3W2CZct__"